import React, { Component } from 'react'
import About from './About';
import Logos from './Logos';
import Skills from './Skills';

export default class AboutContainer extends Component {
    render() {
        return (
            <div>
                <About />
                <div className="m-5">
                    <Logos></Logos>
                </div>
                <div className="m-5"><Skills /></div>
            </div>
        )
    }
}
